export default {
  borderColor: Styles.color.primary,
  disabledBorderColor: Styles.color.disabledBackground,
};
